import React from "react";
import RoleBasedAccess from "./RoleBasedAccess";

/**
 * A React component that renders its children only if the current user is admin.
 *
 * @param {React.ReactNode} props.children - The child elements that will be rendered if the condition is true.
 * @returns {React.ReactElement | ReactFragment} - The rendered React element or empty ReactFragment
 *  if the user is not admin.
 */
function AdminOnlyAccess({ children }) {
  return <RoleBasedAccess roles={["admin_editor", "admin_viewer"]}>{children}</RoleBasedAccess>;
}

export default React.memo(AdminOnlyAccess);
